export const list = (dispatch, apiClient) => apiClient
  .call({ endpoint: 'container/list' })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'CONTAINER_SET', payload: res.data.containers });
    dispatch({ type: 'TASK_SET', payload: res.data.tasks });
    return res;
  });

export const list2 = (dispatch, apiClient, query, ids, skipId) => apiClient
    .call({ endpoint: 'container/list2', data: { query, ...ids, skipId, } })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'CONTAINER_SET', payload: res.data.results });
      return res;
    });


export const find = (dispatch, apiClient, query) => apiClient
  .call({ endpoint: 'container/find', data: { query } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'CONTAINER_SET', payload: res.data.containers });
    dispatch({ type: 'TASK_SET', payload: res.data.tasks });
    return res;
  });

export const create = (dispatch, apiClient, data) => apiClient
  .call({ endpoint: 'container/new', data })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'CONTAINER_SET', payload: res.data });
    return res;
  });

export const get = (dispatch, apiClient, id) =>
  apiClient.call({ endpoint: 'container/get', data: { id } }).then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'CONTAINER_SET', payload: res.data.container });
    dispatch({ type: 'TASK_SET', payload: res.data.tasks });
    dispatch({ type: 'STOCK_SET', payload: res.data.stock });
    dispatch({ type: 'RAW_MATERIAL_STOCK_SET', payload: res.data.rawMaterialStock });
    return res;
  });

export const remove = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'container/remove', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'CONTAINER_SET', payload: res.data });
    return res;
  });

export const update = (dispatch, apiClient, id, changes) => apiClient
  .call({ endpoint: 'container/update', data: { id, changes } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'CONTAINER_SET', payload: res.data });
    return res;
  });



// WEBPACK FOOTER //
// ./app/actions/containers.js